import * as React from 'react';
import { useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import animationData from '../images/mystery box half open.json';
import MysteryLogo from '../images/Mystery logo.json';
export default function UnlockDrawer(props) {
  const { open, setOpen } = props;
  const [bonus, setBonus] = useState(localStorage.getItem('mb_bonus_march_new_cg') || 0);

  const handleClose = () => {
    if (setOpen) setOpen(false);
  };

  useEffect(() => {
    if (!open) return;
    const ck_id = localStorage.getItem('mb_ck_id_march_new_cg');
    if (!ck_id) return;
    fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_mb_mar?ck_id=${ck_id}`)
      .then((res) => res.json())
      .then((data) => {
        const userData = data?.user_data;
        if (userData?.bonus != null) {
          setBonus(userData.bonus);
          localStorage.setItem('mb_bonus_march_new_cg', userData.bonus);
        }
        if (userData?.bonus_added != null) localStorage.setItem('mb_bonus_added_march_new_cg', userData.bonus_added);
        if (userData?.claim != null) localStorage.setItem('mb_open_march_new_cg', userData.claim);
      })
      .catch(() => {});
  }, [open]);

  return (
    <Dialog
      open={open || false}
      onClose={handleClose}
      fullScreen
      PaperProps={{
        sx: {
          margin: 0,
          borderRadius: 0,
          backgroundImage: 'url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first_bg.png)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#403326',
          overflow: 'auto',
        },
      }}
    >
      <DialogContent sx={{ p: 0, overflow: 'auto' }}>
        <Box sx={{ position: 'relative', width: '100%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Lottie animationData={MysteryLogo} loop autoplay style={{ width: '100%' }} />
          </Box>

          <Box>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: '28px',
              }}
            >
              <Box sx={{ textAlign: 'center' }}>
                <Typography
                  sx={{
                    fontFamily: 'Metropolis',
                    fontSize: '16.79px',
                    lineHeight: '100%',
                    fontWeight: 600,
                    color: '#fff',
                    mb: 1,
                  }}
                >
                  You have unlocked
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Metropolis',
                    fontSize: { xs: '44px', sm: '58px' },
                    fontWeight: 900,
                    lineHeight: 1,
                    color: '#E8D7C3',
                    textShadow: `
                      1px 4px 0px #694426,
                      2px 2px 4px rgba(0,0,0,0.25)
                    `,
                  }}
                >
                  ₹{bonus} BONUS <br/> CASHBACK
                </Typography>
              </Box>
            </div>

            <Lottie animationData={animationData} loop autoplay style={{ width: '100%' }} />

          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
